import { QueryClient, useMutation } from '@tanstack/react-query';
import { apiEditor } from 'services/api/api';
import { EditorApiEndpoints } from 'utils/endpoints/endpoints';
import { appendQueryParams } from 'utils/requestUtils';

const invalidateQueries = (queryClient: QueryClient) => queryClient.invalidateQueries({queryKey: ['arquivosEditaveisPaginados']})

export interface SolicitarEdicaoPayload {
  usuarioID: number;
  processamentoID: number;
}

export interface FinalizarEdicaoPayload {
  processamentoID: number;
}

export const solicitarEdicao = async (payload: SolicitarEdicaoPayload) => {
  const response = await apiEditor.post(
    EditorApiEndpoints.SolicitarEdicao,
    payload,
  );
  return response.data;
};

export const useSolicitarEdicao = (queryClient: QueryClient) => {
  return useMutation({
    mutationFn: solicitarEdicao,
    onSuccess: () => invalidateQueries(queryClient),
  });
};

export const cancelarEdicao = async (processamentoID: number) => {
  await apiEditor.delete(
    appendQueryParams(EditorApiEndpoints.CancelarEdicao, { processamentoID }),
  );
};

export const useCancelarEdicao = (queryClient: QueryClient) => {
  return useMutation({
    mutationFn: cancelarEdicao,
    onSuccess: () => invalidateQueries(queryClient),
  });
};

export const reprocessarArquivo = async (processamentoID: number) => {
  const response = await apiEditor.post(
    EditorApiEndpoints.ReprocessarArquivo,
    {},
    {
      headers: {
        'Processamento-Sped-ID': processamentoID.toString(),
      },
    },
  );
  return response.data;
};

export const useReprocessarArquivo = (queryClient: QueryClient) => {
  return useMutation({
    mutationFn: reprocessarArquivo,
    onSuccess: () => invalidateQueries(queryClient),
  });
};

export const finalizarEdicao = async (payload: FinalizarEdicaoPayload) => {
  const response = await apiEditor.post(
    EditorApiEndpoints.FinalizarEdicao,
    payload,
  );
  return response.data;
};

export const useFinalizarEdicao = (queryClient: QueryClient) => {
  return useMutation({
    mutationFn: (payload: FinalizarEdicaoPayload) => finalizarEdicao(payload),
    onSuccess: () => invalidateQueries(queryClient),
  });
};
